module.exports = __webpack_public_path__ + "img/tabBar_1@2x.bccc1bc8.png";